module.exports = __webpack_public_path__ + "img/app.eb365e2d.png";